import type * as mdast from 'mdast';
import type { Handle } from 'mdast-util-to-markdown';
import type * as unist from 'unist';

interface MdastCustomBlock extends unist.Parent {
    type: 'gb-custom-block';
    tagName: string;
    properties: {
        [key: string]: string;
    };
    children: mdast.Content[];
}

/**
 * Create a custom block with a given block name, properties, and children.
 */
export function createCustomBlock(
    blockName: string,
    properties: object,
    children: mdast.Content[]
): mdast.Content {
    return {
        // @ts-expect-error
        type: 'gb-custom-block',
        tagName: blockName,
        properties: {
            ...properties,
        },
        // @ts-expect-error
        children,
    };
}

/**
 * A formatter for gb-custom-block Markdown elements.
 */
export const handleCustomBlockToMarkdown: Handle = function handleCustomBlockToMarkdown(
    node: MdastCustomBlock,
    _,
    context
) {
    // @ts-expect-error
    const exit = context.enter('custom-block');
    // @ts-expect-error
    const subexit = context.enter('body');
    // @ts-expect-error
    const value = context.containerFlow(node, context);
    subexit();
    exit();

    let result = '';
    switch (node.tagName) {
        case 'if':
            result = `{% if ${node.properties.expression} %}`;
            break;
        default: {
            const props = formatCustomProperties(node.properties || {});
            result = `{% ${node.tagName} ${props.length > 0 ? `${props} ` : ''}%}`;
            break;
        }
    }

    if (node.children?.length) {
        result += '\n';
        result += value;
        result += '\n';
        result += `{% end${node.tagName} %}`;
    }

    return result;
};

/**
 * Format a set of properties as a string.
 */
export function formatCustomProperties(properties: { [key: string]: string }): string {
    if ('0' in properties && Object.keys(properties).length === 1) {
        return JSON.stringify(properties['0']);
    }

    return Object.keys(properties)
        .map((propKey) => {
            return `${propKey}="${properties[propKey]}"`;
        })
        .join(' ');
}
